import { render, staticRenderFns } from "./ExpiredAccount.vue?vue&type=template&id=53e6ab2d"
import script from "./ExpiredAccount.vue?vue&type=script&lang=js"
export * from "./ExpiredAccount.vue?vue&type=script&lang=js"
import style0 from "./ExpiredAccount.vue?vue&type=style&index=0&id=53e6ab2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports